function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "emoticon-happy-outline",
  d: "M17.539,10.633a6.906,6.906,0,1,0-6.906,6.906,6.906,6.906,0,0,0,6.906-6.906m1.727,0A8.633,8.633,0,1,1,10.633,2a8.633,8.633,0,0,1,8.633,8.633M8.906,8.475A1.295,1.295,0,1,1,7.611,7.18,1.328,1.328,0,0,1,8.906,8.475m6.043,0A1.295,1.295,0,1,1,13.654,7.18a1.328,1.328,0,0,1,1.295,1.295m-4.316,6.673a4.714,4.714,0,0,1-3.617-1.563l1.226-1.226a2.821,2.821,0,0,0,2.391,1.062,2.821,2.821,0,0,0,2.391-1.062l1.226,1.226A4.714,4.714,0,0,1,10.633,15.148Z",
  transform: "translate(-2 -2)",
  fill: "#818e94"
});

var SvgEmoticon = function SvgEmoticon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17.265,
    height: 17.265,
    viewBox: "0 0 17.265 17.265",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEmoticon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/emoticon.2ecaf9e6.svg";
export { ForwardRef as ReactComponent };